module.exports = __webpack_public_path__ + "static/media/button-arrow.6613c863.svg";